import { estimationActions } from "@/redux/actions/estimation.actions";
import { estimationSelector } from "@/redux/selectors/estimation.selector";
import { useDispatch, useSelector } from "@/redux/store";
import { useCopyPaste } from "../hooks/useCopyPaste";
import { useRef } from "react";
import { SelectionSection } from "./SelectionSection";
import { ClipboardSection } from "./ClipboardSection";

export const SelectionToolbar = ({ estimateId }: { estimateId?: string }) => {
  const dispatch = useDispatch();
  const selectedLineItems = useSelector(estimationSelector.selectedLineItems);
  const selectedCount = selectedLineItems.length;
  const clearSelection = () => dispatch(estimationActions.clearLineItemSelection());
  const { copyItems, copiedLineItems, clearCopiedItems } = useCopyPaste(estimateId);

  const hasSelection = selectedCount > 0;
  const hasClipboard = copiedLineItems.length > 0;
  const isVisible = hasSelection || hasClipboard;

  // Freeze display values so content persists during fade-out animation
  const display = useRef({ hasSelection, hasClipboard, selectedCount, clipboardCount: copiedLineItems.length });
  if (isVisible) {
    display.current = { hasSelection, hasClipboard, selectedCount, clipboardCount: copiedLineItems.length };
  }

  const handleCopy = () => {
    copyItems(selectedLineItems);
    clearSelection();
  };

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 flex-col items-center gap-2 rounded-xl border border-gray-950/10 bg-gray-900 px-4 py-2.5 shadow-2xl transition-all duration-200 ${
        isVisible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      {display.current.hasSelection && (
        <SelectionSection
          selectedCount={display.current.selectedCount}
          onCopy={handleCopy}
          onClear={clearSelection}
        />
      )}
      {!display.current.hasSelection && display.current.hasClipboard && (
        <ClipboardSection
          clipboardCount={display.current.clipboardCount}
          onClear={clearCopiedItems}
        />
      )}
    </div>
  );
};
